import React from 'react'
import PropTypes from 'prop-types'
import Link from 'react-router'
import CustomerForm from './CustomerForm'

const FeaturedContent = (props) => {
  const textStyle = {
    color: '#fff',
    maxWidth: 768,
    marginLeft: props.singleColumn ? 'auto' : '',
    marginRight: props.singleColumn ? 'auto' : '',
  }
  return (
    <section
      style={{
        overflowX: 'hidden', backgroundColor: '#1a5d8c', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat',
      } }
    >

        <div className={`row ${props.singleColumn ? 'text-center flex-nowrap' : null}`}>
          <div className={`col-12 ${!props.singleColumn ? 'col-md-8 col-lg-5' : null} d-flex flex-column justify-content-center align-items-baseline`}>
            <div className={`section ${props.singleColumn ? 'mx-auto' : ''}`}><h3 style={textStyle}><strong>{props.tagline}</strong></h3>
              <p style={textStyle}>{props.subtagline}</p>
              {props.form ? <div className={`w-100 ${props.singleColumn ? 'd-flex justify-content-center' : ''}`}><CustomerForm centered={props.singleColumn} showCustomLabel /></div> : null}
              {props.readMore ? <Link to={props.readMore.link} style={{ color: '#b2ebf2' }}>{props.readMore.text}<i className="material-icons d-inline-flex ml-2" style={{ verticalAlign: 'middle', fontSize: '1rem' }} aria-hidden="true">trending_flat</i></Link> : null}
            </div>
          </div>
          <div className="col-4 d-none d-md-block d-lg-none mb-3">
            {props.miniImage ? <img alt="" src={props.miniImage} className="w-100" /> : null}
          </div>
          <div className={`col-12 col-lg-7 d-none d-lg-block ${props.bottomImage ? 'mt-4' : props.topImage ? 'mb-4' : props.stretchImage ? '' : 'py-4'} order-lg-2`} >
            {!props.bannerImg ?
              <div
                style={{
                  backgroundImage: `url('${props.image}')`,
                  backgroundSize: 'contain',
                  backgroundPosition: `center ${props.bottomImage ? 'bottom' : props.topImage ? 'top' : 'center'}`,
                  backgroundRepeat: 'no-repeat',
                  height: props.imageH,
                  borderRadius: `${props.roundedImage ? '2px' : 0}`,
                  overflow: `${props.roundedImage ? 'hidden' : null}`,
                }}
                className="mw-100 h-100"
              />
              : null}
          </div>
        </div>

    </section>
  )
}

FeaturedContent.propTypes = {
  roundedImage: PropTypes.bool,
  imageH: PropTypes.string,
  miniImage: PropTypes.string,
  tagline: PropTypes.string,
  subtagline: PropTypes.string,
  form: PropTypes.bool,
  stretchImage: PropTypes.bool,
  readMore: PropTypes.string,
  singleColumn: PropTypes.bool,
  topImage: PropTypes.bool,
  image: PropTypes.string,
  bottomImage: PropTypes.bool,
  bannerImg: PropTypes.bool,
}

export default FeaturedContent



// WEBPACK FOOTER //
// ./client/components/FeaturedContent.js